(ns app.front.view.inspections.events
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.ui.dnd :as dnd]
            [app.front.view.application.permissions :as app-permissions]
            [app.front.view.group.admin.inspections.db :as iadb]
            [core.front.event :refer [>evt]]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::inspections-loaded
  (fn [{:keys [db]} [_ status {:keys [entities
                                      qualification-kinds
                                      inspection-actions
                                      visit-types-in-use
                                      visit-results-in-use
                                      result-details-in-use]}]]
    {:db         (-> db
                     (assoc ::iadb/qualification-kinds qualification-kinds)
                     (assoc ::iadb/visit-types-in-use (or visit-types-in-use #{}))
                     (assoc ::iadb/visit-results-in-use (or visit-results-in-use #{}))
                     (assoc ::iadb/result-details-in-use (or result-details-in-use #{}))
                     (assoc :app.front.view.inspections.event-list/inspection-actions inspection-actions))
     :dispatch-n [[::entities/merge-entity-db status (du/entities->entity-db entities)]]}))


(rf/reg-event-fx ::workspace-inspections-loaded
  (fn [{:keys [db]} [_
                     workspace-id
                     _
                     {:keys [inspections-proposed]} :as ev]]
    {:dispatch-n [(into [::inspections-loaded] (drop 2 ev))]
     :db         (-> db
                     (assoc-in [::inspections-proposed workspace-id] inspections-proposed)
                     (update ::fetching disj workspace-id))}))


(rf/reg-event-fx ::fetch-inspections
  (fn [{:keys [db]} [_ workspace-id]]
    (when (and (app-permissions/can-read-inspections-as-authority? db)
               (-> db :view/workspace :group-features (contains? :inspections?)))
      {:db           (-> db
                         (update ::fetching #(conj (or % #{}) workspace-id)))
       :comm/command {:command    :inspection/data-for-workspace
                      :method     :get
                      :data       {:workspace-id workspace-id}
                      :on-success [::workspace-inspections-loaded workspace-id]}})))


(defn on-reorder [target from to]
  (>evt [::process/signal
         target
         [:process.signal/reorder-inspections
          {:inspections (dnd/ordering-tx-for-entity from to)}]]))
